import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getRequestReserveDateFoodMeal, emptyRequestReserveDateFoodMeal} from './Module';
import {Form, Select as SelectInput} from 'antd';
import jMoment from 'components/classes/Jmomen';
import uuidv1 from 'uuid/v1';
import MaterialIcon from 'components/common/MaterialIcon';

@connect((state) => ({
  reserveDateFoodMeal: state.FormBuilder.Common.SelectReserveDateFoodMeal.reserveDateFoodMeal,
}), {
  getRequestReserveDateFoodMeal,
  emptyRequestReserveDateFoodMeal,
})
@autobind
/**
 *
 */
export default class SelectReserveDateFoodMealInfo extends React.PureComponent {
  static propTypes = {
    inline: PropTypes.bool,
    label: PropTypes.string,
    reserveDateFoodMealId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    reserveDateFoodMeal: PropTypes.object,
    getRequestReserveDateFoodMeal: PropTypes.func,
    emptyRequestReserveDateFoodMeal: PropTypes.func,
  };

  static defaultProps = {
    inline: true,
    label: undefined,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      reserveDateFoodMeal: {},
      render: true,
    };
  }


  /**
   *
   */
  componentDidMount() {
    const {getRequestReserveDateFoodMeal} = this.props;
    getRequestReserveDateFoodMeal(this.props.reserveDateFoodMealId, {
      includes: ['dateFoodMeal.food:id,title', 'dateFoodMeal.meal:id,title,color', 'dateFoodMeal.self:id,title'],
    }, (r) => {
      this.setState({reserveDateFoodMeal: r});
    });
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    if (!app._.isEqual(np.reserveDateFoodMealId, this.props.reserveDateFoodMealId)) {
      np.getRequestReserveDateFoodMeal(np.reserveDateFoodMealId, {
        includes: ['food:id,title', 'meal:id,title,color', 'self:id,title'],
      }, (r) => {
        this.setState({reserveDateFoodMeal: r});
      });
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
    this.props.emptyRequestReserveDateFoodMeal();
  }


  /**
   *
   * @return {Object}
   * @private
   */
  _inline() {
    const {inline} = this.props;

    if (inline) {
      return {
        labelCol: {span: 6},
        wrapperCol: {span: 18},
      };
    }

    return {};
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {reserveDateFoodMeal, label} = this.props;

    return (
      <span>
        {`${reserveDateFoodMeal && reserveDateFoodMeal.dateFoodMeal && reserveDateFoodMeal.dateFoodMeal.meal && reserveDateFoodMeal.dateFoodMeal.meal.title
        } - ${reserveDateFoodMeal && reserveDateFoodMeal.dateFoodMeal &&  reserveDateFoodMeal.dateFoodMeal.self && reserveDateFoodMeal.dateFoodMeal.self.title
        } - ${reserveDateFoodMeal && reserveDateFoodMeal.dateFoodMeal && reserveDateFoodMeal.dateFoodMeal.food && reserveDateFoodMeal.dateFoodMeal.food.title}`}
        </span>
    );
  }
}
